import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RootState, useAppSelector, useAppDispatch, loadBoards } from '../../../redux';
import { RoutineAction, Board } from '../../../models';
import { Select } from '../../Select';
import type { Value } from '../../Select';

interface MoveBoardFormProps {
    action: RoutineAction;
    onSave?: (action: RoutineAction) => void;
    projectId?: string;
}

function MoveBoardForm(props: MoveBoardFormProps) {
    const { action, onSave, projectId } = props;
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [options, setOptions] = useState<AnyObj>(action.options || {});
    const { boards } = useAppSelector((state: RootState) => state.boards);

    useEffect(() => {
        if (projectId)
            dispatch(loadBoards({ project: projectId }));
    }, [dispatch, projectId]);
    useEffect(() => { onSave && onSave({ ...action, options }); }, [options]);

    const localized = (value: any) => {
        if (value == null)
            return '';
        if (typeof value === 'string')
            return value;
        return value.fr || value.en || value.de || '';
    };

    const board = (boards || []).find((b: Board) => b._id === options.boardId);
    const boardOptions = (boards || [])
        .filter((b: AnyObj) => (b.columns || []).some((column: AnyObj) => !column.isSmart))
        .map((b: AnyObj) => ({ value: b._id, label: localized(b.name) }));
    const columnOptions = ((board as AnyObj)?.columns || [])
        .filter((c: AnyObj) => !c.isSmart)
        .map((c: AnyObj) => ({
            value: c._id,
            label: localized(c.title) || localized(c.name) || c._id
        }));

    return (
        <div className="flex flex-col space-y-2 w-full">
            <div className="grid grid-cols-1 xl:grid-cols-4 gap-2 bg-purple-50 dark:bg-purple-950/30 p-2 border rounded">
                <label className="text-sm col-span-1">{t('projects.routine.action.choose_board')}</label>
                <div className="col-span-3">
                    <Select
                        defaultValue={options.boardId as Value}
                        options={boardOptions}
                        onChange={(boardId: any) => setOptions({ ...options, boardId, columnId: undefined })}
                        className="border rounded border-gray-300 dark:border-gray-600 w-full"
                        placeholder={t('projects.routine.action.choose_board') || ''}
                    />
                </div>
            </div>
            {options.boardId && (
                <div className="grid grid-cols-1 xl:grid-cols-4 gap-2 bg-purple-50 dark:bg-purple-950/30 p-2 border rounded">
                    <label className="text-sm col-span-1">{t('projects.routine.action.choose_column')}</label>
                    <div className="col-span-3">
                        <Select
                            defaultValue={options.columnId as Value}
                            options={columnOptions}
                            onChange={(columnId: any) => setOptions({ ...options, columnId })}
                            className="border rounded border-gray-300 dark:border-gray-600 w-full"
                            placeholder={t('projects.routine.action.choose_column') || ''}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default MoveBoardForm;
